module.exports = __webpack_public_path__ + "606e5ddc6a3e471307450963c1adb86b.wav";